/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".svi-header[_ngcontent-%COMP%]{display:flex;justify-content:space-between;align-items:flex-start}.back[_ngcontent-%COMP%]{cursor:pointer;height:40px;display:flex;align-items:center;color:#e63923;gap:8px;font-size:12px;font-weight:400}"];
export { styles as styles };
